import { render, staticRenderFns } from "./MembersSection.vue?vue&type=template&id=1120f386&scoped=true&"
import script from "./MembersSection.vue?vue&type=script&lang=ts&"
export * from "./MembersSection.vue?vue&type=script&lang=ts&"
import style0 from "./MembersSection.vue?vue&type=style&index=0&id=1120f386&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1120f386",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SplitView: require('/opt/build/repo/apps/shop/components/storyblok/SplitView/SplitView.vue').default})
